import styled, { keyframes } from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

interface ArrowProps {
    horizontalPosition?: string;
    arrowColor?: string;
    hideArrow?: boolean;
}
export const CartPMMWidgetContainer = styled.div(({ theme }) => ({
    position: "relative",
    padding: `0px ${theme.spacing.xxSmall}  ${theme.spacing.xxSmall}`,
    width: "100%",
}));

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0) rotate(45deg) translateX(-50%);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(45deg) translateX(-50%);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1) rotate(45deg) translateX(-50%);
  }
  to {
    opacity: 0;
    transform: scale(0) rotate(45deg) translateX(-50%);
  }
`;
export const PMMBannerArrow = styled.div<ArrowProps>`
    content: "";
    background: ${props => props.arrowColor};
    border-radius: 2px;
    top: -1px;
    position: absolute;
    left: 0;
    width: 11px;
    height: 11px;
    transform: rotate(45deg) translateX(-50%);
    opacity: ${props => (props.hideArrow ? 0 : 1)};
    animation: ${props => (props.hideArrow ? fadeOut : fadeIn)} 0.2s ease-in-out forwards;
`;

export const PMMBannerContainer = styled.div({
    position: "relative",
});

export const PMMBannerImage = styled(Image)(({ theme }) => ({
    width: "100%",
    borderRadius: `0px 0px ${theme.cornerRadius.small} ${theme.cornerRadius.small}`,
    display: "block",
    height: "100%",
}));
